export const singleIds = ["sby", "sbm", "proc","procm", "tp","tpm"]
// REMOVED: "life" - Lifetime product no longer offered

// Product families map product code to monthly/annual plan IDs
export const productFamilies = {
  sb: {
    name: "Stairs and Buckets",
    monthly: "sbm",
    annual: "sby",
  },
  tp: {
    name: "Million Dollar Road Map",
    monthly: "tpm",
    annual: "tp",
  },
};

// Get product family by product code
export function getProductFamily(productCode) {
  return productFamilies[productCode] || null;
}

export const plans = [
  {
    id: "sbm",
    name: "Million Dollar Stairs and Buckets Start-Up Monthly",
    price: process.env.REACT_APP_SBM_PRICE ? Number(process.env.REACT_APP_SBM_PRICE).toLocaleString("en-US") : "Price not available",
    period: "per month",
    perks: [
      <>
        <strong>10&nbsp;</strong>Seats at your agency
      </>,
      <>
        <strong>Unlimited&nbsp;</strong> Video Sends
      </>,
      <>
       Team <strong>&nbsp;and&nbsp;</strong> Individual Analytics
      </>,
      <>
        <strong>4&nbsp;</strong> Different Languages
      </>,
      <>
      <strong>Free&nbsp;</strong> Training Webinar
    </>,
    ],
  },
  {
    id: "sby",
    name: "Million Dollar Stairs and Buckets Start-Up",
    price: process.env.REACT_APP_SBY_PRICE ? Number(process.env.REACT_APP_SBY_PRICE).toLocaleString("en-US") : "Price not available",
    period: "per year",
    perks: [
      <>
        <strong>10&nbsp;</strong>Seats at your agency
      </>,
      <>
        <strong>Unlimited&nbsp;</strong> Video Sends
      </>,
      <>
       Team <strong>&nbsp;and&nbsp;</strong> Individual Analytics
      </>,
      <>
        <strong>4&nbsp;</strong> Different Languages
      </>,
      <>
      <strong>Free&nbsp;</strong> Training Webinar
    </>,
    ],
  },
  {
    id: "tpm",
    name: "Million Dollar Road Map Monthly",
    price: process.env.REACT_APP_TPM_PRICE ? Number(process.env.REACT_APP_TPM_PRICE).toLocaleString("en-US") : "Price not available",
    items: ["sby", "sbm", "tp1", "tp2", "tp3", "tp4"],
    period: "per month",
    perks: [
      <>
        <strong>10&nbsp;</strong>Seats at your agency
      </>,
      <>
        <strong>$3,000&nbsp;</strong> Non-Compete
      </>,
      <>
       Staff Handbook
      </>,
      <>
        <strong>Million Dollar&nbsp;</strong> Manual
      </>,
      <>
      <strong>All Access&nbsp;</strong> to Sales Processes
    </>,
    ],
  },
  {
    id: "tp",
    name: "Million Dollar Road Map",
    price: process.env.REACT_APP_TP_PRICE ? Number(process.env.REACT_APP_TP_PRICE).toLocaleString("en-US") : "Price not available",
    items: ["sby", "sbm", "tp1", "tp2", "tp3", "tp4"],
    period: "per year",
    perks: [
      <>
        <strong>10&nbsp;</strong>Seats at your agency
      </>,
      <>
        <strong>$3,000&nbsp;</strong> Non-Compete
      </>,
      <>
       Staff Handbook
      </>,
      <>
        <strong>Million Dollar&nbsp;</strong> Manual
      </>,
      <>
        <strong>All Access&nbsp;</strong> to Sales Processes
      </>,
    ],
  },
  // REMOVED: Lifetime product no longer offered
  // {
  //   id: "life",
  //   name: "Million-Dollar Membership",
  //   price: process.env.REACT_APP_LIFE_PRICE ? Number(process.env.REACT_APP_LIFE_PRICE).toLocaleString("en-US") : "Price not available",
  //   period:"one time",
  //   perks: [
  //     <>
  //       <strong>One&nbsp;</strong> Payment
  //     </>,
  //     <>
  //       <strong>Annual&nbsp;</strong> Rocky Mountain Retreat
  //     </>,
  //     <>
  //       Access <strong>&nbsp;Everything</strong>
  //     </>,
  //     <>
  //      <strong>Additional&nbsp;</strong> weekly live trainings.
  //   </>,
  //     <>
  //     <strong>All&nbsp;</strong> additional future content
  //     </>,
  //     <>
  //       <strong>Exclusive&nbsp;</strong> Offers and Events
  //     </>,
  //   ],
  // },
];


export const items = [
  {id: "tp1", name: "Million Dollar Manual", plans: ["tp", "proc"], price: "699.99", period: "per year"},
  {id: "tp2", name: "Comprehensive Staff Handbook", plans: ["tp", "proc"], price: "299.99", period: "per year"},
  {id: "tp3", name: "Paychecks Never Lie", plans: ["tp", "proc"], price: "24.99", period: "one time"},
  {id: "tp4", name: "Bigger Better Paychecks", plans: ["tp", "proc"], price: "24.99", period: "one time"},
  
  {id: "proc1", name: "Sales Process One: Medicare", plans: ["proc"], price: "199.99", period: "per year"},
  {id: "proc2", name: "Sales Process Two: Premium Life", plans: ["proc"], price: "199.99", period: "per year"},
  {id: "proc3", name: "Sales Process Three: Finding the Money", plans: ["proc"], price: "199.99", period: "per year"},
  {id: "proc4", name: "Sales Process Four: Protect & Particpate", plans: ["proc"], price: "199.99", period: "per year"},
  {id: "proc5", name: "Sales Process Five: Understanding Money", plans: ["proc"], price: "199.99", period: "per year"},
  {id: "proc6", name: "Sales Process Six: Liability Wall", plans: ["proc"], price: "199.99", period: "per year"},
  {id: "proc7", name: "Medicare Slide", plans: ["proc"], price: "199.99", period: "per year"},
  // REMOVED: Service Webinars (shuff) no longer offered

]

export function arraysShareElement(arr1, arr2) {
  // Convert the first array to a Set for O(1) lookups
  const set1 = new Set(arr1);
  
  // Check if any element in the second array is in the Set
  for (const element of arr2) {
    if (set1.has(element)) {
      return true; // Return true if a common element is found
    }
  }
}
